import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import MaterialUiTextField from '@material-ui/core/TextField';
import debounce from 'lodash.debounce';

class TextField extends PureComponent {
  state = {
    value: '',
    isChange: false
  };

  onChangeDebounce = debounce(this.onChange, 0);
  onChange(arg) {
    const {onChange} = this.props;
    if (onChange) onChange(arg);
    this.setState({isChange: false});
  }

  handlerOnChange = (e) => {
    const {length} = this.props;

    let value = (e.target.value === '' ? undefined : e.target.value);
    if (length && value && value.length > length)
      value = value.substring(0, length);

    this.setState({value, isChange: true});
    this.onChangeDebounce(value);
  };

  componentWillMount() {
    this.onChangeDebounce = debounce(this.onChange, this.props.debounce || 0);
  }

  componentWillReceiveProps(nextProp, nextState) {
    if (nextProp.debounce !== this.props.debounce)
      this.onChangeDebounce = debounce(this.onChange, nextProp.debounce || 0);
  }

  render() {
    const {value: propValue, style, placeholder, type, className, onBlur, rows, label} = this.props;
    const {value: stateValue, isChange} = this.state;
    const value = (isChange ? stateValue : propValue) || '';
    return (
      <MaterialUiTextField
        label={label}
        rows={rows}
        multiline={rows && rows > 1}
        onBlur={onBlur}
        style={style}
        className={className}
        onChange={this.handlerOnChange}
        value={value}
        type={type}
        placeholder={placeholder}
      />
    );
  }
}

TextField.propTypes = {
  rows: PropTypes.number,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  length: PropTypes.number,
  debounce: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.number,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string
};

export default TextField;


// WEBPACK FOOTER //
// ./src/components/common/TextField/TextField.jsx